//react
import { useState, useContext } from 'react';
//context
import { SideMenuContext } from '../context/SideMenuContext';
import { AuthData } from '../auth/AuthWrapper';
//local components
import { ConfirmationModal } from './ConfirmationModal';
import { TfiClose } from "react-icons/tfi";
import { useGetUserInfo } from "../hooks/useGetUserInfo";
import { RiLogoutBoxRLine } from "react-icons/ri";
import Shadow from './General/Shadow';


const SideMenu = ({ children, onClick }) => {
    const sideMenuContext = useContext(SideMenuContext);
    const { name, profilePhoto } = useGetUserInfo();
    const { signOutUser } = AuthData().useFirebaseSignOut();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const onSigningOut = () => {
        setIsModalOpen(true);
    }

    return (
        <>
            <Shadow onClick={sideMenuContext.closeMenu} />
            <aside className="h-screen fixed left-0 top-0 z-40">
                
                {isModalOpen && <ConfirmationModal
                    title="Та гарахдаа итгэлтэй байна уу?"
                    onClose={() => setIsModalOpen(false)}
                    buttonCancelText="Цуцлах"
                    onConfirm={signOutUser}
                    buttonConfirmText="Гарах"
                >
                    <div className="text-sm text-gray-600">Та гарах үйлдлийг баталгаажуулах гэж байна.</div>
                </ConfirmationModal>}
    
                <nav className="h-full flex flex-col w-64 shadow-xl bg-white border-r border-gray-100">
                    <div className="h-12 px-4 flex justify-between items-center bg-gradient-to-r from-blue-50 to-indigo-50 border-b">
                        <div className="font-semibold text-gray-700">MyTools</div>
                        <button className="p-1.5 rounded-md hover:bg-gray-100">
                            <TfiClose onClick={() => sideMenuContext.closeMenu()} />
                        </button>
                    </div>
                    <ul className="flex-1 px-2 py-1.5 space-y-0.5 overflow-y-auto">
                        {children}
                    </ul>
                    <div className="border-t flex p-3 justify-between items-center bg-white/60">
                        <div className="flex">
                            <img src={profilePhoto} alt="" className="w-8 h-8 rounded-full ring-2 ring-white" />
                            <div className="font-medium pl-2 text-gray-800">{name}</div>
                        </div>
                        <div className={`cursor-pointer p-2 rounded-md hover:bg-gray-100 text-gray-700`} onClick={onSigningOut}>
                            <RiLogoutBoxRLine />
                        </div>
                    </div>
                </nav>
            </aside>
                
        </>
    );
};

export default SideMenu;
